module.exports = __webpack_public_path__ + "img/login_form.307c6ca5.png";